export const NZBSU_CATEGORY_LABELS: Record<string, string> = {
  '2000': 'Movies All',
  '2045': 'Movies UHD',
  '5000': 'TV All',
  '5045': 'TV UHD',
};

const CATEGORY_SEPARATOR = /\s*(?:%\^<|,)\s*/;

export function formatNzbsuCategory(category?: string): string | undefined {
  if (!category) {
    return undefined;
  }

  const labels = category
    .split(CATEGORY_SEPARATOR)
    .filter(Boolean)
    .map(value => NZBSU_CATEGORY_LABELS[value] ?? (/^\d+$/.test(value) ? 'Other' : value));
  return labels.length ? labels.join(', ') : undefined;
}
